import * as storage from '../utils/storage';

export function GetLocalApiKey() {
    const apiKey = storage.getGoogleApiKey();

    return apiKey;
}

export function GetABCUsage() {
    const abcUsage = storage.getAbcUsage();

    return abcUsage === true;
}